import axios from 'axios'
import Loader from '@/components/Loader/Loader.vue'
import moment from 'moment'

export default {
  name: 'Form',
  components: { Loader },
  data() {
    return {
      viewDocusignData:'',
      loader1: false
    }
  },
  mounted() {
    this.getDocusignUsers();
  },
  methods: {
    connectDocusign(){
      console.log("sdlfksjdflkj")
      this.loader1 = true
      let url = '/api/v1/Connect_docusign'
      axios.get(url).then((res)=>{
        this.$toast.success("Redirecting to Docusign", {
          position: "bottom-center",
          timeout: 4000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });     
        window.location.href = res.data.url
        this.loader1 = false
       
      }).catch(err=>{
        this.loader1 = false
      });
    },
    redirectToTolls(){
      let url = '/api/v1/redirect_link'
      axios.get(url).then((res)=>{
        window.location = res.data.return_url

      })
    },
    getDocusignUsers(){
      this.loader1 = true
      let url = '/api/v1/Get_Docusign_users'

      axios.get(url).then((res)=>{
        this.viewDocusignData= res.data.data
        this.loader1 = false
        this.$nextTick(() => {
          $('#table_dynamic_report_').dataTable()
          $('#table_dynamic_report_').DataTable().destroy()
          $('#table_dynamic_report_').DataTable({
              scrollX: true,
              lengthChange: true,
              info: false,
              sorting: [[0, "asc"]],
              initComplete: function(settings, json) {
                  $('.dataTables_scrollBody tfoot tr').css({visibility:'collapse'});
                  $('.dataTables_scrollBody thead tr').css({visibility:'collapse'});
              },
              language: {
                  search: "", searchPlaceholder: "Search...", paginate: {
                      first: "",
                      previous: "<",
                      next: ">",
                      last: "",
                  },
                  lengthMenu: "<h5>Show entries</h5> _MENU_"
              },
          })
          $('#table_dynamic_report_filter > label').append(
              `<div class='search_icon'><img src='${search}' /></div>`
          );
        });
      }).catch(err=>{
        this.loader1 = false
      })
    },
    removeDocusignUser(email){
      let payload={
        email:email
      }
      let url = '/api/v1/Remove_Docusign_Account'
      if(confirm("Confirm Delete")){
      axios.post(url,payload).then((res)=>{
        $('#table_dynamic_report_').DataTable().destroy()
        this.getDocusignUsers()
      }).catch(err=>{
        self.$toast.error("Error!", {
          position: "bottom-center",
          timeout: 2000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });     
      })
    };
    }
  }
}



